<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
    <div
      class="w-[400px] h-[400px] rounded-xl shadow-lg p-8 flex flex-col items-center justify-center transform transition-all hover:shadow-xl gap-6 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-100"
    >
      <img
        src="../assets/logo.png"
        alt="Logo"
        class="w-24 h-24 mb-2"
      />
      <h1
        class="text-4xl font-bold text-center bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
      >
        Welcome Developers
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import { useTheme } from '../utils/useTheme'

export default defineComponent({
  name: 'Landing',
  setup() {
    const theme = inject('theme', useTheme())

    return {
      theme
    }
  }
})
</script>

<style scoped>
.bg-clip-text {
  -webkit-background-clip: text;
}
</style>
